<template>
<div
    v-if="agencies.length"
    class="agencies-advertising"
>
    <div class="agency-title">
        {{ this.title }}
    </div>

    <my-carousel
        v-cloak
        :per-page-custom="perPage"
        :scroll-per-page="true"
        :pagination-enabled="true"
        :navigation-enabled="true"
        :navigation-next-label="'<span></span>'"
        :navigation-prev-label="'<span></span>'"
    >
        <slide v-for="agency in agencies" :key="agency.id">
            <div class="card" :class="agency.network">
                <div class="agency-data agency-heading d-flex align-items-center pt-0">
                    <img :src="'/img/icons/icon-' + agency.network + '.svg'" :alt="agency.network" width="30" height="30" />
                    <div class="agency-heading-data">
                        <strong><span class="affiliate-label">{{ trans('labels.affiliate') }}:</span> {{ agency.name }}</strong><br />
                        <span>{{ agency.district }}, {{ agency.zip_code }} {{ agency.city.title }}</span>
                    </div>
                </div>
                <div class="adv-agency adv-website" :class="agency.network">
                    <div class="row">
                        <div class="col-6 ml-1">
                            <h4>{{ trans('adv_agency.adv_website') }}</h4>
                            <a :href="agency.url_agency" class="btn btn-adv-website" :class="agency.network" target="_blank">{{ trans('labels.homepage') }}</a>
                        </div>
                        <div class="col-6"></div>
                    </div>
                </div>
            </div>
        </slide>

        <slide>
            <div class="card">
                <div class="adv-agency-banner" style="background-image:url('/img/adv-find-agency.svg');background-repeat:no-repeat">
                    <div class="row">
                        <a :href="trans('adv_agency.adv_agencies_home')" target="_blank">
                            <div class="col-7 ml-1 adv-placeholder pr-0">
                                <h4>{{ trans('adv_agency.adv_find_agencies') }}</h4>
                            </div>
                            <div class="col-5"></div>
                        </a>
                    </div>
                </div>
            </div>
        </slide>

        <slide v-if="agencies.length < 2">
            <div class="card">
                <div class="adv-agency-banner" style="background-image:url('/img/adv-evaluation.svg');background-repeat:no-repeat">
                    <div class="row">
                        <a :href="trans('adv_agency.adv_evaluation_index')" target="_blank">
                            <div class="col-6 ml-1 adv-placeholder">
                                <h4>{{ trans('adv_agency.adv_evaluation') }}</h4>
                            </div>
                            <div class="col-6"></div>
                        </a>
                    </div>
                </div>
            </div>
        </slide>

        <slide v-if="agencies.length < 1">
            <div class="card">
                <div class="adv-agency-banner" style="background-image:url('/img/adv-group-work.svg');background-repeat:no-repeat">
                    <div class="row">
                        <a :href="trans('adv_agency.adv_work_home')" target="_blank">
                            <div class="col-7 ml-1 adv-placeholder">
                                <h4>{{ trans('adv_agency.adv_works') }}</h4>
                            </div>
                            <div class="col-5"></div>
                        </a>
                    </div>
                </div>
            </div>
        </slide>
    </my-carousel>
  </div>
</template>

<script>
import MyCarousel from '../MyCarousel'
export default {
    components: {
        'my-carousel': MyCarousel,
    },

    props: {
        search: {
            type: Object,
            required: true,
        },
        
        perPage: {
            type: Array,
            default() {
                return [[0, 1], [769, 1], [950, 2], [1110, 1], [1340, 1], [1440, 2], [2160, 3]]
            },
        },
    },

    data() {
        return {
            agencies: [],
            place: null,
            title: ''
        }
    },

    computed: {
        lang() {
            return this.$root.lang.agency_card
        }
    },

    mounted() {
        axios.get('/api/agencies/advertising', {
                params: this.search
            })
            .then((response) => {
                this.agencies = response.data

                if (this.agencies.length)
                    if (!this.search.districts) {
                        this.title = this.lang.adv_agency.agency_title_city.replace(':city', this.agencies[0].city.title)
                    } else if (String(this.search.districts).includes('|')) {
                        this.title = this.lang.adv_agency.agency_title_districts.replace(':city', this.agencies[0].city.title)
                    } else {
                        this.title = this.lang.adv_agency.agency_title_district.replace(':city', this.agencies[0].city.title)
                    }
            })
            .catch((error) => {
                // console.log(error)
            })
    }
}
</script>